import blog1 from "../../assets/images/meeting-with-client-for-gathering-requirements.avif";
import blog2 from "../../assets/images/brainstorming-the-best-software-solutions.avif";
import blog3 from "../../assets/images/website-designers-discussing-low-fidelity-mockups.avif";
import blog4 from "../../assets/images/coding-on-a-computer.avif";
import blog5 from "../../assets/images/software-testing.avif"; 

export const process = [
  {
    title: "Discovery & Requirements Gathering",
    image: blog1,
    description:
      "We listen first and listen well, making sure you’re heard and understood before being presented with a solution for your vision and goals. ",
  },
  {
    title: "Ideation  & Planning",
    image: blog2,
    description:
      "Our experts brainstorm the smartest technical solution to your requirements and present the actionable software architecture and workflows.",
  },
  {
    title: "Design & prototyping",
    image: blog3,
    description:
      "Aesthetically pleasing mockups for the software’s user-interface are presented which are further elaborated by interactive prototyping to demonstrate the software’s functionality and user-experience. ",
  },
  {
    title: "Development & testing",
    image: blog4,
    description:
      "Our in-house team of specialists executes the full-stack coding of software, while ensuring top-notch quality assurance protocols at each stage.  ",
  },
  {
    title: "Deployement & Maintenance",
    image: blog5,
    description:
      "From hassle-free launch to consistent support and upgrades, we’ve got you covered.  ",
  },
];
export const faqData = [
  {
    id: "01",
    question:
      "What’s the difference between a basic website and a web application?",
    answer:
      "Unlike static websites, web applications deliver dynamic and data-powered experiences. Features include personalized user dashboards, real time database interactions, and automated workflows tailored to your business needs.",
  },
  {
    id: "02",
    question: "Do web apps offer convenient content management?",
    answer:
      "Yes. With headless CMS integration, empower non-technical teams to manage content effortlessly, publish across multiple channels simultaneously, and maintain full version control from a single dashboard.",
  },
  {
    id: "03",
    question: "How do web apps provide better API control?",
    answer:
      "Web apps allow granular API management by processing legacy API outputs to modern standards, rate limiting/throttling, and centralized monitoring through a unified interface.",
  },
  {
    id: "04",
    question: "Are web portals user-friendly for non-tech teams?",
    answer:
      "Expertly architected web apps implement RBAC (role-based access control) and audit logs to track changes without any technical skills.",
  },
  {
    id: "05",
    question: "Can I upgrade my existing website to a web app?",
    answer:
      "At Apptalyst, we have the technical prowess to transform sites built on monolithic architecture into SaaS platforms. We implement a modular development and deployment approach to ensure a seamless transition.  ",
  },
];